import { render, staticRenderFns } from "./SuficienciaForm.vue?vue&type=template&id=a6182ce4&"
import script from "./SuficienciaForm.vue?vue&type=script&lang=js&"
export * from "./SuficienciaForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports